import { isValidUuId } from '@shared/utils/uuid';
import { PartnerHotelDetailsRouteQueryParams, PartnerHotelIdType } from '../HotelBooking.types';
import { JoyHotelQueryStringParameters } from '@shared/components/DiscountsProvider/hotels/HotelsDiscountsProvider';
import { useQueryParamHelper } from '@shared/core/queryString';
import { UtmParameters } from '@shared/core/router.helper/RoutesContext';
import { useUtmParameters } from '@shared/utils/utmParameters';

export const usePartnerHotelQueryParams = (travelPlaceIdArg?: string | null) => {
  const queryParamHelper = useQueryParamHelper();
  const utmParamsFromHook = useUtmParameters();

  // Retrieve query parameters
  const getQueryParam = (param: PartnerHotelDetailsRouteQueryParams | JoyHotelQueryStringParameters) => queryParamHelper.getValueString(param);

  // @todo - Cleanup with ticket - https://withjoy.atlassian.net/browse/TRAV-622
  const travelPlaceId = travelPlaceIdArg || getQueryParam(PartnerHotelDetailsRouteQueryParams.joyPlaceId);

  const idTypeParam = getQueryParam(PartnerHotelDetailsRouteQueryParams.idType) || '';
  const isValidHotelIdType = !!PartnerHotelIdType[idTypeParam as PartnerHotelIdType]; // Validate is valid idtype
  const sourceType = isValidUuId(travelPlaceId) ? PartnerHotelIdType.joy : isValidHotelIdType ? (idTypeParam as PartnerHotelIdType) : PartnerHotelIdType.hotels; // convert value to HotelIdType
  const source = getQueryParam(PartnerHotelDetailsRouteQueryParams.source);

  const queryParamEventId = getQueryParam(PartnerHotelDetailsRouteQueryParams.eventId);
  const utmParams: Partial<UtmParameters & { utm_source_secondary?: string }> = utmParamsFromHook || {};
  const discountCode = getQueryParam(PartnerHotelDetailsRouteQueryParams.discountCode);
  // used for native travel checkout
  const joyHotelDiscountCode = getQueryParam(JoyHotelQueryStringParameters.joyHotelDiscountCode);

  return { travelPlaceId, sourceType, source, queryParamEventId, utmParams, discountCode, joyHotelDiscountCode };
};
